import { flow } from 'lodash';

import { NAME } from './dialogCardDetail.constant';

import { selectState as selectStateDialog } from '../dialogs.selector';

const selectStateKey = (state) => state[NAME];
const selectVisibleKey = (state) => state.visible;
const selectPayloadKey = (state) => state.payload;

export const selectState = flow(selectStateDialog, selectStateKey);
export const selectVisible = flow(selectState, selectVisibleKey);
export const selectPayload = flow(selectState, selectPayloadKey);
